import * as i0 from '@angular/core';
import { Injectable, Component, NgModule } from '@angular/core';
import { map } from 'rxjs/operators';
import * as i1 from '@angular/common/http';

class IndianPostalCodesService {
    constructor(http) {
        this.http = http;
    }
    findByPinCode(pinCode) {
        return this.http.get('https://api.postalpincode.in/pincode/' + pinCode).pipe(map((data) => {
            return data;
        }));
    }
    findByPostOfficeName(postOffice) {
        return this.http.get('https://api.postalpincode.in/postoffice/' + postOffice).pipe(map((data) => {
            return data;
        }));
    }
}
IndianPostalCodesService.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesService, deps: [{ token: i1.HttpClient }], target: i0.ɵɵFactoryTarget.Injectable });
IndianPostalCodesService.ɵprov = i0.ɵɵngDeclareInjectable({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesService, providedIn: 'root' });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesService, decorators: [{
            type: Injectable,
            args: [{
                    providedIn: 'root'
                }]
        }], ctorParameters: function () { return [{ type: i1.HttpClient }]; } });

class IndianPostalCodesComponent {
    constructor() { }
    ngOnInit() {
    }
}
IndianPostalCodesComponent.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesComponent, deps: [], target: i0.ɵɵFactoryTarget.Component });
IndianPostalCodesComponent.ɵcmp = i0.ɵɵngDeclareComponent({ minVersion: "14.0.0", version: "14.1.1", type: IndianPostalCodesComponent, selector: "lib-indian-postal-codes", ngImport: i0, template: ``, isInline: true });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesComponent, decorators: [{
            type: Component,
            args: [{
                    selector: 'lib-indian-postal-codes',
                    template: ``
                }]
        }], ctorParameters: function () { return []; } });

class IndianPostalCodesModule {
}
IndianPostalCodesModule.ɵfac = i0.ɵɵngDeclareFactory({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesModule, deps: [], target: i0.ɵɵFactoryTarget.NgModule });
IndianPostalCodesModule.ɵmod = i0.ɵɵngDeclareNgModule({ minVersion: "14.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesModule, declarations: [IndianPostalCodesComponent], exports: [IndianPostalCodesComponent] });
IndianPostalCodesModule.ɵinj = i0.ɵɵngDeclareInjector({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesModule });
i0.ɵɵngDeclareClassMetadata({ minVersion: "12.0.0", version: "14.1.1", ngImport: i0, type: IndianPostalCodesModule, decorators: [{
            type: NgModule,
            args: [{
                    declarations: [
                        IndianPostalCodesComponent
                    ],
                    imports: [],
                    exports: [
                        IndianPostalCodesComponent
                    ]
                }]
        }] });

/*
 * Public API Surface of indian-postal-codes
 */

/**
 * Generated bundle index. Do not edit.
 */

export { IndianPostalCodesComponent, IndianPostalCodesModule, IndianPostalCodesService };
